module.exports = __webpack_public_path__ + "img/9.20b648c6.png";